import React, { memo, useEffect } from 'react'
import { StoreProvider } from 'easy-peasy'
import AppStore from '@v4/store/appStore'
import I18nextProvider from '@v4/components/common/I18nextProvider'
import ErrorBoundary from '@v4/components/common/ErrorBoundary'
import PropTypes from 'prop-types'
import Embedding from './components/Embedding'

const AppLayout = ({ initialScroll, children, builderStore, appModel }) => {
	useEffect(() => {
		if (initialScroll) {
			window?.scrollTo(0, initialScroll, 'app')
			try {
				window.sessionStorage.removeItem(`scrollPosition ${window.history.state?.url || ''}`)
				// eslint-disable-next-line no-empty
			} catch (e) {}
		}
		const jssStyles = document.querySelector('#jss-server-side')

		if (jssStyles) {
			jssStyles.parentElement.removeChild(jssStyles)
			document.head.appendChild(jssStyles)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<StoreProvider store={builderStore}>
			<AppStore.Provider runtimeModel={appModel}>
				<I18nextProvider>
					<ErrorBoundary>
						<div id="top" style={{ visibility: 'hidden' }} />
						<Embedding>{children}</Embedding>
						<div id="bottom" style={{ visibility: 'hidden' }} />
					</ErrorBoundary>
				</I18nextProvider>
			</AppStore.Provider>
		</StoreProvider>
	)
}

AppLayout.propTypes = {
	builderStore: PropTypes.object.isRequired,
	appModel: PropTypes.object.isRequired,
	initialScroll: PropTypes.number,
	children: PropTypes.node,
}

export default memo(AppLayout)
